module.exports = __webpack_public_path__ + "static/food_delivery_mobile_app_cover-79b0d70da30b052b5b218f9a82a54a0f.png";